import { createFileRoute, Outlet } from "@tanstack/react-router";

const Route = createFileRoute("/_authorized/consent-solutions")({
  component: () => <Outlet />,
});

export { Route };
